export const locale = {
  marathon_health: 'Marathon Health',
};
